import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SearchResult, SearchItemV3_With_ID } from '@app/styles';
import { ModuleFE_MacroTag } from '../../_entity.js';
import { Component_HealthcareSpace } from '../healthcare-space/index.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { Component_MacroTagEditor } from './Component_MacroTagEditor/Component_MacroTagEditor.js';
export const SearchItem_MacroTag = SearchItemV3_With_ID({
    route: Component_HealthcareSpace.Route,
    module: ModuleFE_MacroTag,
    type: ModuleFE_MacroTag.dbDef.entityName,
    entityName: ModuleFE_MacroTag.dbDef.dbKey,
    groupId: ['Healthcare Space'],
    tags: [],
    mapper: macro => [macro.label],
    entityLabel: 'Macro Tag',
    renderer: (macro, selected, onClickCallback) => {
        return _jsx(Renderer_SearchResult, { itemId: macro._id, itemKey: ModuleFE_MacroTag.dbDef.entityName, entityLabel: 'Macro Tag', itemLabel: macro.label, hierarchy: 'Healthcare Space', selected: selected, onClickCallback: onClickCallback });
    },
    resultRenderer: (macroId) => {
        const macro = ModuleFE_MacroTag.cache.unique(macroId);
        if (!macro)
            throw new MUSTNeverHappenException(`Could not get macro for id ${macroId}`);
        const editable = new EditableDBItemV3(macro, ModuleFE_MacroTag);
        return _jsx(Component_MacroTagEditor, { editable: editable, editMode: false });
    }
});
//# sourceMappingURL=search-item.js.map